<template>
    <div>
        <p class="caption mb-1" style="text-align: left;">
            Informe por quantos pontos o item sai e o multiplicador é preenchido sozinho.
        </p>

        <v-row dense>
            <v-col cols="12" sm="6">
                <v-text-field
                    v-model="textoPontos"
                    :disabled="!base"
                    :hint="base ? 'O que o cliente gasta de pontos' : 'Informe o preço do item primeiro'"
                    label="Pontos para resgatar"
                    placeholder="0"
                    v-mask="['#######']"
                    type="tel"
                    autocomplete="off"
                    persistent-hint
                    outlined
                    dense
                    @input="aplicarPontos"
                    @focus="editandoPontos = true"
                    @blur="editandoPontos = false; sincronizar()"
                />
            </v-col>

            <v-col cols="12" sm="6">
                <v-text-field
                    v-model="textoMultiplicador"
                    :error-messages="erroMultiplicador"
                    label="Multiplicador de pontos"
                    hint="Pontos por real do preço"
                    placeholder="0.00"
                    type="tel"
                    autocomplete="off"
                    persistent-hint
                    outlined
                    dense
                    @input="aplicarMultiplicador"
                    @focus="editandoMultiplicador = true"
                    @blur="editandoMultiplicador = false; sincronizar()"
                />
            </v-col>
        </v-row>

        <div class="caption mt-2" style="text-align: left;">
            <template v-if="!base">
                Informe o preço do item para calcular os pontos.
            </template>
            <template v-else-if="erroMultiplicador">
                O multiplicador mínimo é {{ minimo }}, ou seja, no mínimo {{ pontosMinimos }} pontos para este item.
            </template>
            <template v-else-if="pontosResgate">
                {{ formatBRL(base) }} × {{ valorCampo }} = <b>{{ pontosResgate }} pontos</b> para resgatar.
                Complementos pagos entram na conta: com adicionais, o mesmo item custa mais pontos.
            </template>
            <template v-else>
                Preencha um dos campos acima para definir o resgate.
            </template>
        </div>
    </div>
</template>

<script>
import { codigoMoeda } from '@/utils/moeda';
export default {
    name: 'PontosResgateInput',

    props: {
        value: {
            type: [ String, Number, Boolean ],
            default: '',
        },

        preco: {
            type: [ String, Number ],
            default: '',
        },

        minimo: {
            type: Number,
            default: 1,
        },
    },

    data: () => ({
        textoPontos: '',
        textoMultiplicador: '',
        editandoPontos: false,
        editandoMultiplicador: false,
    }),

    watch: {
        value: {
            immediate: true,
            handler() {
                this.sincronizar();
            },
        },

        preco() {
            this.sincronizar();
        },
    },

    computed: {
        valorCampo() {
            return [ '', null, undefined, false ].includes(this.value) ? '' : String(this.value);
        },

        base() {
            return parseFloat(this.preco) || 0;
        },

        multiplicador() {
            return parseFloat(this.value) || 0;
        },

        pontosResgate() {
            if (!this.base || !this.multiplicador) {
                return 0;
            }

            return Math.round(this.multiplicador * this.base);
        },

        pontosMinimos() {
            return Math.round(this.minimo * this.base);
        },

        erroMultiplicador() {
            return this.valorCampo && this.multiplicador < this.minimo ? `Mínimo ${this.minimo}` : '';
        },
    },

    methods: {
        aplicarPontos() {
            const pontos = parseInt(this.textoPontos, 10) || 0;

            if (!this.base || !pontos) {
                this.$emit('input', '');
                return;
            }

            this.$emit('input', (Math.round((pontos / this.base) * 100) / 100).toFixed(2));
        },

        aplicarMultiplicador() {
            this.$emit('input', this.limpar(this.textoMultiplicador));
        },

        limpar(texto) {
            const [ inteiro, ...casas ] = String(texto == null ? '' : texto)
                .replace(',', '.')
                .replace(/[^\d.]/g, '')
                .split('.');

            const decimais = casas.join('').slice(0, 2);

            return inteiro.slice(0, 5) + (decimais ? `.${decimais}` : '');
        },

        sincronizar() {
            if (!this.editandoPontos && (parseInt(this.textoPontos, 10) || 0) !== this.pontosResgate) {
                this.textoPontos = this.pontosResgate ? String(this.pontosResgate) : '';
            }

            if (!this.editandoMultiplicador && this.textoMultiplicador !== this.valorCampo) {
                this.textoMultiplicador = this.valorCampo;
            }
        },

        formatBRL(n) {
            return (parseFloat(n) || 0).toLocaleString('pt-br', { style: 'currency', currency: codigoMoeda() });
        },
    },
};
</script>
